module.exports = __webpack_public_path__ + "static/media/S2b.3babc7a6.png";